// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'core-js/es6/promise';
import 'core-js/es6/string';
import 'core-js/es7/array';
// import cssVars from 'css-vars-ponyfill';
import '@/config';
import '@/_axios';
import '@/_moment';
// import IsOffline from '@/_isOffline';
import { i18n } from '@/_translate';

import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue';
import { abilitiesPlugin, Can } from '@casl/vue';
import Alerts from 'vue-notification';
import store from '@/store/index';
import App from '@/App';
import router from '@/router';
import ability from '@/_ability';

import AlertsMixin from '@/mixins/AlertsMixin';
import FormErrors from '@/mixins/FormErrors';
import DatePickerMixin from '@/mixins/DatePickerMixin';

import GAuth from 'vue-google-oauth2';

// todo
// cssVars()

const gauthOption = {
  clientId: window.ENV.VUE_APP_OAUTH_GOOGLE_CLIENT_ID,
  scope: 'profile email',
  prompt: 'select_account'
};

Vue.use(BootstrapVue);
Vue.use(Alerts, { componentName: 'Alerts' });
Vue.use(abilitiesPlugin, ability);

Vue.component('Can', Can);

Vue.mixin(AlertsMixin);
Vue.mixin(FormErrors);
Vue.mixin(DatePickerMixin);

if (window.ENV.VUE_APP_OAUTH_GOOGLE_CLIENT_ID) {
  Vue.use(GAuth, gauthOption);
}

// Vue.use(IsOffline, { pingUrl: (`${Backend.defaults.baseURL}/ping`).replace(/([^:]\/)\/+/g, '$1') });

Vue.filter('flag', (langKey) => {
  const extraFlags = {
    en: 'gb-eng'
  };
  if (extraFlags[langKey]) {
    return extraFlags[langKey];
  }
  return langKey;
});

/* eslint-disable no-new */
new Vue({
  i18n,
  el: '#app',
  router,
  template: '<App/>',
  components: {
    App
  },
  store
});
